<app-popover>
  <div class="h-[15rem] w-[25rem] overflow-y-auto">
    <div app-popover-header class="font-semibold" translate>gestor-avaliacoes.aplicacao.help-text.ajuda</div>
    <hr app-divider />
    <div class="flex flex-col gap-4" app-popover-content>
      @switch (type) {
        @case (TypeHelpActivityEnum.Eclass) {
          <div class="flex flex-col gap-2">
            <span translate>eclass.tarefa.aluno-responde-eclass-lenda</span>
          </div>
        }
        @case (TypeHelpActivityEnum.Late) {
          <div class="flex flex-col gap-2">
            <span translate>eclass.tarefa.envio-atrasado-lenda</span>
          </div>
        }
        @case (TypeHelpActivityEnum.Evaluative) {
          <div class="flex flex-col gap-2">
            <span translate>eclass.tarefa.avaliativo-lenda</span>
          </div>
        }
      }
    </div>
  </div>
</app-popover>
